import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {Card, CardTitle, CardText} from 'material-ui/Card';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actionCreators from '../actions';
import CenteredSpinner from '../components/CenteredSpinner';

class ListItemContent extends Component {

   fetchData(token, articleKey) {
      const {actions} = this.props;
      actions.fetchArticleData(token, articleKey);
   }

   componentDidMount(){
      const {token, articleKey, isArticleDataFetching, articleData} = this.props;

      if (!isArticleDataFetching && !!articleKey && (!articleData || articleData.key !== articleKey)){
         this.fetchData(token, articleKey);
      }
   }

   componentWillReceiveProps(nextProps){
      const {token, articleKey, isArticleDataFetching} = this.props;

      if (!isArticleDataFetching && nextProps.articleKey !== articleKey){
         this.fetchData(token, nextProps.articleKey);
      }
   }

   render() {
      const {title} = this.props;
      const {isArticleDataFetching, articleData} = this.props;

      return (
         <Card
            style={{marginTop: 20}}
            className="Article">
            <CardTitle title={title} titleStyle={{lineHeight:'26px'}} titleColor="rgb(0, 188, 212)"/>
            <CardText>
               <div>
                  {articleData && isArticleDataFetching === false
                     ? <div>
                        <div className="ArticleContent" dangerouslySetInnerHTML={{__html: articleData.fields.custom_calc_article_front}}/>
                     </div> :
                     <CenteredSpinner />
                  }
               </div>
            </CardText>
         </Card>
      )
   }
}
;

ListItemContent.propTypes = {
   title: PropTypes.element.isRequired,
   token: PropTypes.string.isRequired,
   articleKey: PropTypes.string.isRequired,
   articleData: PropTypes.object,
   isArticleDataFetching: PropTypes.bool
};

const mapStateToProps = (state) => ({
   token: state.auth.token,
   articleKey: state.data.currentArticleKey,
   articleData: state.data.articleData,
   isArticleDataFetching: state.data.isArticleDataFetching
});

const mapDispatchToProps = (dispatch) => ({
   actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ListItemContent);



// WEBPACK FOOTER //
// ./src/components/ListItemContent.js